module.exports = __webpack_public_path__ + "static/img/4157_phase_function_Paper_Points.ba422c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4157_phase_function_Paper_Points.png
// module id = loGd
// module chunks = 0